var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebUxIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 236.83 236.83",
    style: {
      enableBackground: "new 0 0 236.83 236.83"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6D6E71;}\n\t.st1{fill:#939598;}\n\t.st2{fill:#808285;}\n\t.st3{fill:#D1D3D4;}\n\t.st4{fill:#A7A9AC;}\n\t.st5{fill:#BCBEC0;}\n\t.st6{fill:#EA2B7B;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{fill:#46C7F4;}\n\t.st9{fill:#94AACF;}\n\t.st10{fill:#FBED1D;}\n\t.st11{fill:#E8C062;}\n\t.st12{fill:#DAE378;}\n\t.st13{fill:#D3CC81;}\n\t.st14{fill:#95AACF;}\n\t.st15{fill:#E9C162;}\n\t.st16{fill:#DAE478;}\n\t.st17{fill:#D4CC82;}\n\t.st18{fill:#EB2D7C;}\n\t.st19{fill:#46C8F5;}\n\t.st20{fill:#FCEE1F;}\n\t.st21{opacity:0.5;fill:#EA2B7B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 189.96,
    className: "st6",
    width: 236.83,
    height: 46.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    width: 236.83,
    height: 46.87
  }), /*#__PURE__*/React.createElement("rect", {
    y: 94.98,
    className: "st10",
    width: 236.83,
    height: 46.87
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebUxIcon);
export default __webpack_public_path__ + "static/media/web-ux-icon.28627618c1b6b81a3c78e2a812a8e6cb.svg";
export { ForwardRef as ReactComponent };